/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreditUnionDocumentResponseDto { 
    id?: number;
    documentId?: string;
    fileName?: string | null;
    typeId?: number;
    title?: string | null;
    creationDate?: string | null;
    fileType?: string | null;
    fileData?: string | null;
}

